import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { section, field, gallery } from "../app/schema";

export const GET_SECTION = "GET_SECTION";
export const PATCH_SECTION = "PATCH_SECTION";
export const DELETE_SECTION = "DELETE_SECTION";
export const GET_SECTION_FIELDS = "GET_SECTION_FIELDS";
export const POST_SECTION_FIELDS = "POST_SECTION_FIELDS";
export const GET_SECTION_GALLERIES = "GET_SECTION_GALLERIES";
export const POST_SECTION_GALLERIES = "POST_SECTION_GALLERIES";

export const SET_IS_EDIT_SECTION_MODAL_VISIBLE = "SET_IS_EDIT_SECTION_MODAL_VISIBLE";
export const SET_IS_REMOVE_SECTION_MODAL_VISIBLE = "SET_IS_REMOVE_SECTION_MODAL_VISIBLE";
export const SET_IS_ADD_GALLERY_MODAL_VISIBLE = "SET_IS_ADD_GALLERY_MODAL_VISIBLE";

export const MOVE_SECTION = "MOVE_SECTION";

// Validation
const validateForm = {
  createSectionField: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createSectionGallery: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise
};

// Requests

const getSectionGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchSection = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/sections/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteSection = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych sekcji, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getSectionFieldsGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}/fields`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postSectionFields = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}/fields`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const getSectionGalleriesGet = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}/galleries`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postSectionGalleries = (fetch, apiHost, accessToken, data, uid) =>
  fetch(`${apiHost}/v1/sections/${uid}/galleries`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

export function getSection(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_SECTION],
    payload: {
      promise: getSectionGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, section);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateSection(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_SECTION],
    payload: {
      promise: patchSection(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, section);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeSection(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_SECTION],
    payload: {
      promise: deleteSection(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getSectionFields(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_SECTION_FIELDS],
    payload: {
      promise: getSectionFieldsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(field));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function createSectionField(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_SECTION_FIELDS],
    payload: {
      promise: validateForm
        ["createSectionField"](validate, data)
        .then(() =>
          postSectionFields(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, field);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function getSectionGalleries(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_SECTION_GALLERIES],
    payload: {
      promise: getSectionGalleriesGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(gallery));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    },
    meta: {
      uid
    }
  });
}

export function createSectionGallery(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_SECTION_GALLERIES],
    payload: {
      promise: validateForm
        ["createSectionGallery"](validate, data)
        .then(() =>
          postSectionGalleries(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, gallery);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsEditSectionModalVisible(value) {
  return {
    type: SET_IS_EDIT_SECTION_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsRemoveSectionModalVisible(value) {
  return {
    type: SET_IS_REMOVE_SECTION_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsAddGalleryModalVisible(value) {
  return {
    type: SET_IS_ADD_GALLERY_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

// Standard functions
export function validateFormFieldSections(form, name, value) {
  const feature = "sections";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}

export function moveSection(dragIndex, hoverIndex, moveActionProps) {
  return {
    type: MOVE_SECTION,
    payload: {
      dragIndex,
      hoverIndex,
      moveActionProps
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/sections/actions.js